/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCaretRight = createReactComponent("outline", "caret-right", "IconCaretRight", [["path", { "d": "M10 18l6 -6l-6 -6v12", "key": "svg-0" }]]);

export { IconCaretRight as default };
//# sourceMappingURL=IconCaretRight.mjs.map
